import React from 'react';
import { motion } from 'framer-motion';
import { Hammer, Wrench, HardHat, Compass, Pencil, GraduationCap } from 'lucide-react';
const audience = [{
  title: 'Carpinteros de aluminio',
  icon: Hammer
}, {
  title: 'Instaladores',
  icon: Wrench
}, {
  title: 'Constructores',
  icon: HardHat
}, {
  title: 'Arquitectos',
  icon: Compass
}, {
  title: 'Diseñadores',
  icon: Pencil
}, {
  title: 'Personas que quieren aprender desde cero',
  icon: GraduationCap
}];
export function Audience() {
  return <section className="py-24 relative" data-id="element-16">
      <div className="absolute inset-0 bg-blueprint opacity-20" data-id="element-17" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-19">
          <h2 className="text-4xl md:text-5xl font-bold font-heading mb-6" data-id="element-20">
            ¿Para quién es esta colección?
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 max-w-4xl mx-auto" data-id="element-21">
          {audience.map((item, idx) => {
          const Icon = item.icon;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="glass-panel rounded-2xl p-6 flex flex-col items-center text-center gap-4 hover:bg-white/5 transition-colors" data-id="element-22">
                <div className="w-12 h-12 rounded-full bg-[#2F80ED]/10 flex items-center justify-center" data-id="element-23">
                  <Icon className="w-6 h-6 text-[#2F80ED]" data-id="element-24" />
                </div>
                <h3 className="font-semibold text-gray-200" data-id="element-25">{item.title}</h3>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}